
import styles from "../styles/style.module.scss";
import Input from "../../input";
import moment from 'moment';
import deleteImage from "../../../images/delete.svg";
import { functionService } from "../../../lib/functions";

export default function Session({
  setTrainingData,
  sessions,
  index,
  handleSessionDelete,
  errorArray,
}) {
  const handleDateChange = (e) => {
    e.persist();
    setTrainingData((latestTrainingData) => ({
      ...latestTrainingData,
      sessions: sessions.map((session, currentIndex) => {
        if (currentIndex === index) {
          console.log("  moment(e.target.value).format() ->", moment(e.target.value).format());
          console.log("moment().format() ->",moment().format())
          return { ...session, startDateTime: moment(e.target.value).format() };
        } else {
          return session;
        }
      }),
    }));
  };

  const handleInputChange = (e) => {
    e.persist();

    setTrainingData((latestTrainingData) => ({
      ...latestTrainingData,
      sessions: sessions.map((session, currentIndex) => {
        if (currentIndex === index) {
          return { ...session, [e?.target?.name]: `${e?.target?.value}` };
        } else {
          return session;
        }
      }),
    }));
  };

  const deleteSession = async ({ id, index }) => {
    try {
      const { status } = await functionService.remove(`session/${id}`);
      if (status) {
        handleSessionDelete({ deleteIndex: index });
      }
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <div className={styles.session}>
      <div className={styles.sessionHeading}>
        <label className={styles.sessionLabel}>Session {`${index + 1}`}</label>

        {index !== 0 && (
          <img
            src={deleteImage}
            className={styles.deleteSession}
            onClick={() => deleteSession({ id: sessions[index].id, index })}
          />
        )}
      </div>

      <div>
        <div style={{ display: "flex" }} className={styles.details}>
          <Input
            error={errorArray?.includes("title")}
            label="Title"
            type="text"
            placeholder="new session title"
            value={sessions[index].title}
            name="title"
            onChangeHandler={handleInputChange}
          />

          <div className={styles.inputDiv}>
            <label className={styles.inputLabel}>Start Date & Time</label>
            <input
              type={"datetime-local"}
              value={moment(sessions[index].startDateTime).format(
                "YYYY-MM-DD HH:mm"
              )}
              onChange={handleDateChange}
            />
          </div>

          <Input
            label="Duration(in hours)"
            type="number"
            placeholder="e.g:2 hours"
            value={sessions[index].duration}
            name="duration"
            error={errorArray?.includes("duration")}
            onChangeHandler={handleInputChange}
          />

          <Input
            label="Trainer Name"
            type="text"
            placeholder="Trainer name"
            value={sessions[index]?.teacherName}
            onChangeHandler={handleInputChange}
            name="teacherName"
            error={errorArray?.includes("teacherName")}
          />
          <Input
            label="Recording Link"
            type="text"
            placeholder="RecordingLink"
            value={sessions[index]?.recordingLink}
            onChangeHandler={handleInputChange}
            name="recordingLink"
            error={errorArray?.includes("recordingLink")}
          />

          <Input
            label="Meeting Link"
            type="text"
            placeholder={"Meeting link"}
            value={sessions[index]?.meetingLink}
            onChangeHandler={handleInputChange}
            name="meetingLink"
            error={errorArray?.includes("meetingLink")}
          />
        </div>
      </div>
    </div>
  );
}
